import HEADER_NAV_LINK_LIST from "contants/header-nav-link";
import { URL_DOWNLOAD } from "contants/url-download";
import { Link } from "react-router-dom";

import StyledHeaderNav from "./index.style";

const HeaderNav = () => {
  const handleOnclick = (key: number) => {
    if (key === 8) {
      const apkFileName = URL_DOWNLOAD.split("/").pop();

      const downloadLink = document.createElement("a");
      downloadLink.href = URL_DOWNLOAD;
      downloadLink.download = apkFileName || "";

      document.body.appendChild(downloadLink);
      downloadLink.click();

      document.body.removeChild(downloadLink);
      return;
    }
  };

  return (
    <StyledHeaderNav>
      {HEADER_NAV_LINK_LIST.map((item) => (
        <Link
          onClick={() => handleOnclick(item.key)}
          key={item.key}
          to={item.to}
          className="header__wrap-item"
        >
          <item.icon className="icon" />
          <p>{item.link}</p>
        </Link>
      ))}
    </StyledHeaderNav>
  );
};

export default HeaderNav;
